import React from 'react';
import { compose } from '../../../reactApolloCompat';
import { withRouter } from '../../../util/withRouter';
import Label from '../../../component/form/Label';
import { stringIsNullOrEmpty } from '../../../util/strings';

function LeftLabel(props) {
    const { className, variant, label, children } = props;

    let cssVariant = null;
    if (!stringIsNullOrEmpty(variant)) cssVariant = `left-label--${variant}`;

    return (
        <div className={`left-label ${cssVariant || ''}`}>
            <div className="label-container">
                <Label className={`label ${className || ''}`}>{label}</Label>
            </div>
            <div className="field-container">{children}</div>
        </div>
    );
}

export default compose(withRouter)(LeftLabel);
